export default {
  title: '编辑门店',
  url: '/expandstore/shopEdit' // 埋点用，记录所属模块
};
